"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanels = void 0;

var _react = _interopRequireDefault(require("react"));

var TabPanels = function TabPanels(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _react["default"].Children.map(children, function (tab, i) {
    return tab ? /*#__PURE__*/_react["default"].cloneElement(tab, {
      index: i
    }) : null;
  }));
};

exports.TabPanels = TabPanels;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJUYWJQYW5lbHMiLCJjaGlsZHJlbiIsIlJlYWN0IiwiQ2hpbGRyZW4iLCJtYXAiLCJ0YWIiLCJpIiwiY2xvbmVFbGVtZW50IiwiaW5kZXgiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UYWJzL1RhYlBhbmVscy50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGNvbnN0IFRhYlBhbmVsczogUmVhY3QuRkM8UmVhY3QuUHJvcHNXaXRoQ2hpbGRyZW48dW5rbm93bj4+ID0gKHtcbiAgY2hpbGRyZW4sXG59KSA9PiAoXG4gIDw+XG4gICAge1JlYWN0LkNoaWxkcmVuLm1hcChjaGlsZHJlbiwgKHRhYjogSlNYLkVsZW1lbnQsIGkpID0+XG4gICAgICB0YWJcbiAgICAgICAgPyBSZWFjdC5jbG9uZUVsZW1lbnQodGFiLCB7XG4gICAgICAgICAgICBpbmRleDogaSxcbiAgICAgICAgICB9KVxuICAgICAgICA6IG51bGxcbiAgICApfVxuICA8Lz5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUVPLElBQU1BLFNBQXFELEdBQUcsU0FBeERBLFNBQXdEO0VBQUEsSUFDbkVDLFFBRG1FLFFBQ25FQSxRQURtRTtFQUFBLG9CQUduRSxrRUFDR0MsaUJBQUEsQ0FBTUMsUUFBTixDQUFlQyxHQUFmLENBQW1CSCxRQUFuQixFQUE2QixVQUFDSSxHQUFELEVBQW1CQyxDQUFuQjtJQUFBLE9BQzVCRCxHQUFHLGdCQUNDSCxpQkFBQSxDQUFNSyxZQUFOLENBQW1CRixHQUFuQixFQUF3QjtNQUN0QkcsS0FBSyxFQUFFRjtJQURlLENBQXhCLENBREQsR0FJQyxJQUx3QjtFQUFBLENBQTdCLENBREgsQ0FIbUU7QUFBQSxDQUE5RCJ9